<div class="mat-dialog-container">
  <div class="dialog-header">
    <div class="dialog-close">
      <a mat-mini-fab (click)="close()">
        <mat-icon aria-label="Close Icon" class="close-icon">close</mat-icon>
      </a>
    </div>
    <div class="mat-dialog-title">
      <h5>{{data.title}}</h5>
    </div>
  </div>
  <div class="dialog-content">
    <div class="first-instruction">
      <p>Please pay your bill by selecting the Payments tab above the top of the next page.</p>
    </div>
    <div class="second-instruction">
      <p>
        To avoid late charges, please select the total outstanding balance option within the payment screen.
      </p>
    </div>
  </div>
</div>
